import { notifyAEPPayloadUpdate } from "../../externalApi/AepApi";
import { isFeatureEnabled } from "../../externalApi/VelocityApi";
import { WidgetApi } from "../orchestrator/WidgetApi";
export class WidgetPreviewApi extends WidgetApi {
    async sendContent(payload, widgetId, instanceId) {
        const isAugmentedEntryPointEnabled = isFeatureEnabled("Feature_AugmentedEntryPoint");
        if (!isAugmentedEntryPointEnabled) {
            throw new Error("Feature_AugmentedEntryPoint is not enabled");
        }
        notifyAEPPayloadUpdate(payload, widgetId, instanceId.toString(), false);
    }
}
